import { sanitizeURL } from "@mma/common";
import React from "react";
import { useLocation } from "react-router-dom";
import { securityCenter } from "../../../constants/static";
import { IURLAssetReference } from "../../../interfaces/urlAssetReference";
import utils from "../../../utils/helperFunction";
import { Title } from "../title/Title";

import styles from "./parentFragment.module.scss";

const getTitleId = (label: string) => label.trim().toLocaleLowerCase().split(" ").join("-");

type ParentFragmentType = {
  data: undefined | IURLAssetReference[] | null;
};

const ParentFragmentHTML: React.FC<ParentFragmentType> = ({ data }) => {
  const { search, pathname } = useLocation();
  const path = pathname.startsWith(`/${securityCenter}`) ? pathname : `/${securityCenter}${pathname}`;

  if (!data) {
    return null;
  }

  return (
    <div>
      {data.map(({ title = "", description = "", label = "" }, index) => {
        const _description = utils.changeHrefAttributeFromString(description, {
          search: sanitizeURL(search),
          pathname: sanitizeURL(path),
        });
        return (
          <div key={utils.uuid()}>
            {index !== 0 && <Title id={getTitleId(label)}>{title}</Title>}
            <div
              className={styles.bamDescription}
              dangerouslySetInnerHTML={{
                __html: _description?.body?.innerHTML || "",
              }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default ParentFragmentHTML;
